import React from 'react'
import { TudoAli, TudoRef, TudoMulti } from 'assets/img/card-icons'

export const aleloTudoGroups = [
    {
        desc: 'Alimentação',
        type: 'TX_DISP_ALIMENTACAO',
        baseType: 'TUDO_NEW',
        code: 12,
        isPat: [true, false],
        taxName: 'Tarifa Alimentação',
        tooltipDesc: (
            <>
                Benefício utilizado para a
                <br /> compra de alimentos em
                <br /> ampla rede credenciada de
                <br /> supermercados, açougues,
                <br /> quitandas e similares.
            </>
        ),
        icon: TudoAli,
        order: 0,
        feeType: 'AMOUNT'
    },
    {
        desc: 'Refeição',
        type: 'TX_DISP_REFEICAO',
        baseType: 'TUDO_NEW',
        code: 13,
        isPat: [true, false],
        taxName: 'Tarifa Refeição',
        tooltipDesc: (
            <>
                Benefício voltado ao
                <br /> pagamento das refeições em
                <br /> ampla rede credenciada, que
                <br /> inclui restaurantes,
                <br /> lanchonetes e similares.
            </>
        ),
        icon: TudoRef,
        order: 1,
        feeType: 'AMOUNT'
    },
    {
        desc: 'Benefícios',
        type: 'TX_DISP_BENEFICIOS',
        baseType: 'TUDO_NEW',
        code: 14,
        isPat: [true, false],
        taxName: 'Tarifa Benefícios',
        tooltipDesc: (
            <>
                É a solução de antecipação
                <br /> salarial que proporciona ao
                <br /> seu colaborador os maiores
                <br /> descontos em medicamentos
                <br /> do mercado chegando
                <br /> em até 85%.
            </>
        ),
        icon: TudoMulti,
        order: 2,
        feeType: 'AMOUNT'
    }
]
